<template>
  <fusioncharts
      :type="type"
      :width="width"
      :height="height"
      :dataformat="dataFormat"
      :dataSource="dataSource"
      ref="fc"
  >
  </fusioncharts>
</template>

<script>
import Vue from 'vue';
import VueFusionChartsComponent from 'vue-fusioncharts/component';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import Candy from 'fusioncharts/themes/fusioncharts.theme.candy';
import Gammel from 'fusioncharts/themes/fusioncharts.theme.gammel';

const vueFusionCharts = VueFusionChartsComponent(FusionCharts, Charts, Candy, Gammel);

Vue.component('fusioncharts', vueFusionCharts);

export default {

  name: "FusionColumn2d",

  props: {
    chartConfig: {
      type: Object
    },
    chartData: {
      type: Array
    }
  },

  data: () => ({
    type: "",
    width: "100%",
    height: "500",
    dataFormat: "json",
    dataSource: {
      chart: {
        exportEnabled: 1,
        caption: "",
        subcaption: "",
        xaxisname: "",
        yaxisname: "",
        theme: localStorage.getItem('dark') === 'true' ? 'candy' : 'gammel',
        bgColor: localStorage.getItem('dark') === 'true' ? "#1e1e1e" : "#ffffff",
        showValues: 0,
      },
      data: []
    }
  }),

  computed: {

    currentTheme: function () {
      return this.$vuetify.theme.dark ? 'candy' : 'gammel'
    },

  },

  watch: {

    currentTheme() {
      this.onThemeChanged()
    },

    chartData() {
      this.setDataSource()
    }

  },

  methods: {

    onThemeChanged: function () {
      this.$refs.fc.chartObj.setChartAttribute("theme", this.currentTheme);
      this.$refs.fc.chartObj.setChartAttribute("bgColor", this.currentTheme === 'candy' ? '#1e1e1e' : '#ffffff');
    },

    setDataSource: function () {
      this.dataSource.data = this.chartData
      this.type = this.chartConfig.type
      this.dataSource.chart.caption = this.chartConfig.caption
      this.dataSource.chart.subcaption = this.chartConfig.subcaption
      this.dataSource.chart.xaxisname = this.chartConfig.xaxisname
      this.dataSource.chart.yaxisname = this.chartConfig.yaxisname
      this.dataSource.chart.showValues = this.chartConfig.showValues
      this.dataSource.chart.labelDisplay = this.chartConfig.labelDisplay
      this.dataSource.chart.labelStep = this.chartConfig.labelStep
    }

  }

}
</script>

<style scoped>

</style>